<template>
  <div>
    <template v-if="viaje?.id">
      <!-- CARD PERSONA -->
      <template v-for="(reserva, index) in resumenReservas" :key="reserva.id">
        <div class="card-persona mb-10">
          <div
            class="persona-header d-flex align-items-center justify-content-between py-3 bg-primary-light"
            :class="[
              { collapsed: isCollapsed[index], 'opacity-50': reserva.estado === ESTADOS_RESERVA.CANCELADA },
              isMisReservas ? 'px-20' : 'px-15',
            ]"
            @click="toggleCollapse(index)">
            <div class="d-flex align-items-center flex-grow-1">
              <div class="icono-persona me-2">
                <IconOccupied
                  :user="reserva.usuario && reserva.usuario.nombre ? reserva.usuario : getUserForIcon(index)"
                  :all-colors="true"
                  :thin-border="true" />
              </div>
              <div class="d-flex align-items-center flex-wrap">
                <span
                  class="p medium"
                  :class="reserva.estado === ESTADOS_RESERVA.CANCELADA ? 'text-danger' : 'text-landing'">
                  <template v-if="reserva.usuario && reserva.usuario.nombre">
                    {{ reserva.usuario.nombre }} {{ reserva.usuario.apellido }}
                  </template>
                  <template v-else>
                    <span>{{ $t('general.persona') }} {{ index + 1 }}/</span>
                    <span>{{
                      alojamiento && alojamientoHasHabs ? alojamiento.habitacion.numPlazas : resumenReservas.length
                    }}</span>
                  </template>
                </span>
                <template v-if="reserva.estado === ESTADOS_RESERVA.CANCELADA">
                  <span class="badge text-bg-danger ms-2 translate">{{ reserva.estado }}</span>
                  <button
                    type="button"
                    class="btn btn-link btn-sm text-decoration-underline p-0 ms-2"
                    @click.stop="recuperarReserva">
                    {{ $t('reserva.recuperarReserva') }}
                  </button>
                </template>
              </div>
            </div>
            <CustomIcon
              v-if="!reserva.hasConflictoEdad"
              :icon="isCollapsed[index] ? arrowDownIcon : arrowUpIcon"
              size="14px"
              class="pointer text-landing" />
          </div>

          <div v-if="reserva.hasConflictoEdad" class="p-15 text-landing">
            {{ $t('servicios.sinServicioValidoEdad') }}
          </div>
          <transition name="collapse">
            <div v-show="!isCollapsed[index] && !reserva.hasConflictoEdad" class="collapse-content">
              <!-- SERVICIOS INCLUIDOS -->
              <div :class="isMisReservas ? 'px-20 py-15' : 'p-15'" class="text-landing">
                <div class="d-flex justify-content-between align-items-center mb-10">
                  <span class="bold small-m" :class="isMisReservas ? 'p' : 'small'">{{
                    $t('input.field.incluidPaqueteBasico')
                  }}</span>
                  <span v-if="!isInscripcion" class="bold text-landing small-m" :class="isMisReservas ? 'p' : 'small'">
                    {{ formatPrice(reserva.precioDesdeViaje) }} {{ agenciaStore.getCurrency }}
                  </span>
                </div>
                <!-- ALOJAMIENTO -->
                <template v-if="alojamiento">
                  <div class="servicio-item mb-10 text-landing">
                    <div class="d-flex align-items-start">
                      <img
                        :src="viaje.cabeceraAlojamientos?.icono ?? accommodationIcon"
                        class="servicio-icon text-landing"
                        :style="{ width: isMisReservas ? '16px' : '14px', height: isMisReservas ? '16px' : '14px' }"
                        :alt="alojamiento.nombre" />
                      <div class="flex-grow-1">
                        <div class="d-flex align-items-center">
                          <div
                            class="me-2 small-m alojamiento-nombre"
                            :class="isMisReservas ? 'p' : 'small'"
                            @click="goToAlojamiento(alojamiento.id)">
                            {{ alojamiento.nombre }}
                          </div>
                        </div>
                        <a
                          v-if="alojamiento?.cupos?.[0]?.observaciones || alojamiento?.habitacion?.observaciones"
                          href="#"
                          class="text-landing sub text-decoration-underline pointer"
                          @click.prevent="
                            openModalCondicionesAlojamiento(
                              alojamiento?.cupos?.[0]?.observaciones || alojamiento?.habitacion?.observaciones
                            )
                          ">
                          {{ $t('general.condiciones') }}
                        </a>
                        <div
                          class="descripcion-servicio text-landing-light sub-m"
                          :class="isMisReservas ? 'small' : 'sub'">
                          {{ alojamiento.descripcion }}
                        </div>
                        <div class="text-landing-light sub-m translate" :class="isMisReservas ? 'small' : 'sub'">
                          {{ getAlojamientoInfo(alojamiento) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- SERVICIOS PAQUETE BASICO -->
                <template v-for="swc in getServiciosPaqueteBasico(reserva)" :key="swc.servicio.id">
                  <div v-if="swc.servicio.paqueteBasico" class="servicio-item mb-10 text-landing">
                    <div class="d-flex align-items-start">
                      <template v-if="getServiceIcon(swc.servicio).type === TipoIconoServicio.IMAGE">
                        <img
                          :src="getServiceIcon(swc.servicio).value"
                          class="servicio-icon text-landing"
                          :style="{ width: isMisReservas ? '16px' : '14px', height: isMisReservas ? '16px' : '14px' }"
                          :alt="swc.servicio.nombre" />
                      </template>
                      <template v-if="getServiceIcon(swc.servicio).type === TipoIconoServicio.ICON">
                        <CustomIcon
                          :icon="getServiceIcon(swc.servicio).value"
                          class="servicio-icon text-landing"
                          :size="isMisReservas ? '16px' : '14px'" />
                      </template>
                      <div class="flex-grow-1">
                        <div class="d-flex align-items-center">
                          <div class="translate mb-1 me-2 small-m" :class="isMisReservas ? 'p' : 'small'">
                            {{ swc.servicio.nombre }}
                          </div>
                          <a
                            v-if="swc.servicio.infoExtra || getAdjuntosServicio(swc.servicio).length > 0"
                            href="#"
                            class="text-landing sub text-decoration-underline pointer"
                            data-bs-toggle="modal"
                            :data-bs-target="`#infoExtraModalPB${reserva.id}-${swc.servicio.id}`"
                            @click.prevent.stop>
                            + {{ $t('general.info') }}
                          </a>
                          <button
                            v-if="
                              isMisReservas &&
                              swc.servicio.seguro &&
                              swc.servicio.subtipo === 'cancelacion' &&
                              reserva.documentacionSeguroCancelacion
                            "
                            class="btn-recibo p-0 text-decoration-underline text-landing sub semibold ms-2"
                            @click.stop="descargarDocumentacion(reserva)">
                            <DownloadIcon class="me-1" />
                            {{ $t('botones.documentacion') }}
                          </button>
                        </div>
                        <div
                          v-if="hasServiceDates(swc.servicio)"
                          class="descripcion-servicio text-landing-light translate sub-m"
                          :class="isMisReservas ? 'small' : 'sub'">
                          {{ formatServiceDateRange(swc.servicio) }}
                        </div>
                        <div
                          v-if="swc.servicio.atributos"
                          class="descripcion-servicio text-landing-light translate sub-m"
                          :class="isMisReservas ? 'small' : 'sub'">
                          {{ getAtributos(swc.servicio) }}
                        </div>
                        <div
                          v-if="swc.servicio.descripcion"
                          class="text-landing-light translate sub-m"
                          :class="isMisReservas ? 'small' : 'sub'">
                          {{ swc.servicio.descripcion }}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- SERVICIOS PAQUETE BASICO REMPLAZADOS -->
                <template
                  v-for="swc in getServiciosPaqueteBasicoUpsell(reserva)"
                  :key="`reemplazado-${swc.servicioPB.id}`">
                  <div class="servicio-item mb-10 text-landing">
                    <div class="d-flex align-items-start">
                      <template v-if="getServiceIcon(swc.servicioPB).type === TipoIconoServicio.IMAGE">
                        <img
                          :src="getServiceIcon(swc.servicioPB).value"
                          class="servicio-icon text-landing"
                          :style="{ width: isMisReservas ? '16px' : '14px', height: isMisReservas ? '16px' : '14px' }"
                          :alt="swc.servicioPB.nombre" />
                      </template>
                      <template v-if="getServiceIcon(swc.servicioPB).type === TipoIconoServicio.ICON">
                        <CustomIcon
                          :icon="getServiceIcon(swc.servicioPB).value"
                          class="servicio-icon text-landing"
                          :size="isMisReservas ? '16px' : '14px'" />
                      </template>
                      <div class="flex-grow-1">
                        <div
                          class="translate text-decoration-line-through small-m"
                          :class="isMisReservas ? 'p' : 'small'">
                          {{ swc.servicioPB.nombre }}
                        </div>
                        <div
                          v-if="hasServiceDates(swc.servicioPB)"
                          class="descripcion-servicio text-landing-light translate text-decoration-line-through sub-m"
                          :class="isMisReservas ? 'small' : 'sub'">
                          {{ formatServiceDateRange(swc.servicioPB) }}
                        </div>
                        <div
                          v-if="swc.servicioPB.atributos"
                          class="descripcion-servicio text-landing-light translate text-decoration-line-through sub-m"
                          :class="isMisReservas ? 'small' : 'sub'">
                          {{ getAtributos(swc.servicioPB) }}
                        </div>
                        <div
                          v-if="swc.servicioPB.descripcion"
                          class="text-landing-light translate text-decoration-line-through sub-m"
                          :class="isMisReservas ? 'small' : 'sub'">
                          {{ swc.servicioPB.descripcion }}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- SERVICIOS UPSELL -->
                <template v-for="swc in getServiciosPaqueteBasicoUpsell(reserva)" :key="`upsell-${swc.servicio.id}`">
                  <div class="servicio-item mb-10 text-landing">
                    <div class="d-flex align-items-start justify-content-between">
                      <div class="d-flex align-items-start flex-grow-1">
                        <template v-if="getServiceIcon(swc.servicio).type === TipoIconoServicio.IMAGE">
                          <img
                            :src="getServiceIcon(swc.servicio).value"
                            class="servicio-icon text-landing"
                            :style="{ width: isMisReservas ? '16px' : '14px', height: isMisReservas ? '16px' : '14px' }"
                            :alt="swc.servicio.nombre" />
                        </template>
                        <template v-if="getServiceIcon(swc.servicio).type === TipoIconoServicio.ICON">
                          <CustomIcon
                            :icon="getServiceIcon(swc.servicio).value"
                            class="servicio-icon text-landing"
                            :size="isMisReservas ? '16px' : '14px'" />
                        </template>
                        <div class="flex-grow-1">
                          <div class="d-flex align-items-center">
                            <div class="translate mb-1 me-2 small-m" :class="isMisReservas ? 'p' : 'small'">
                              {{ swc.servicio.nombre }}
                            </div>
                            <a
                              v-if="swc.servicio.infoExtra || getAdjuntosServicio(swc.servicio).length > 0"
                              href="#"
                              class="text-landing sub text-decoration-underline pointer"
                              data-bs-toggle="modal"
                              :data-bs-target="`#infoExtraModalUpsell${reserva.id}-${swc.servicio.id}`"
                              @click.prevent.stop>
                              + {{ $t('general.info') }}
                            </a>
                          </div>
                          <div
                            v-if="hasServiceDates(swc.servicio)"
                            class="descripcion-servicio text-landing-light translate sub-m"
                            :class="isMisReservas ? 'small' : 'sub'">
                            {{ formatServiceDateRange(swc.servicio) }}
                          </div>
                          <div
                            v-if="swc.servicio.atributos"
                            class="descripcion-servicio text-landing-light translate sub-m"
                            :class="isMisReservas ? 'small' : 'sub'">
                            {{ getAtributos(swc.servicio) }}
                          </div>
                          <div
                            v-if="swc.servicio.descripcion"
                            class="text-landing-light translate sub-m"
                            :class="isMisReservas ? 'small' : 'sub'">
                            {{ swc.servicio.descripcion }}
                          </div>
                        </div>
                      </div>
                      <div v-if="!isInscripcion" class="bold text-landing" :class="isMisReservas ? 'p' : 'small'">
                        {{ getPrecioIncremento(swc) > 0 ? '+' : '' }}{{ formatPrice(getPrecioIncremento(swc)) }}
                        {{ agenciaStore.getCurrency }}
                      </div>
                    </div>
                  </div>
                </template>
              </div>

              <div v-if="reserva.precioBase > 0 && !isInscripcion" class="divisor-horizontal ml-15 mr-15" />

              <!-- SERVICIOS EXTRAS -->
              <template v-if="getServiciosExtras(reserva).length > 0">
                <div :class="isMisReservas ? 'px-20 py-15' : 'p-15'" class="text-landing">
                  <div class="bold mb-10" :class="isMisReservas ? 'p' : 'small'">
                    {{ $t('reserva.extras') }}
                  </div>

                  <template v-for="swc in getServiciosExtras(reserva)" :key="swc.servicio.id">
                    <div class="servicio-item mb-10 text-landing">
                      <div class="d-flex align-items-start justify-content-between">
                        <div class="d-flex align-items-start flex-grow-1">
                          <template v-if="getServiceIcon(swc.servicio).type === TipoIconoServicio.IMAGE">
                            <img
                              :src="getServiceIcon(swc.servicio).value"
                              class="servicio-icon"
                              :style="{
                                width: isMisReservas ? '16px' : '14px',
                                height: isMisReservas ? '16px' : '14px',
                              }"
                              :alt="swc.servicio.nombre" />
                          </template>
                          <template v-if="getServiceIcon(swc.servicio).type === TipoIconoServicio.ICON">
                            <CustomIcon
                              :icon="getServiceIcon(swc.servicio).value"
                              class="servicio-icon"
                              :size="isMisReservas ? '16px' : '14px'" />
                          </template>
                          <div class="flex-grow-1">
                            <div class="d-flex align-items-center">
                              <div class="translate mb-1 me-2 small-m" :class="isMisReservas ? 'p' : 'small'">
                                {{ swc.servicio.nombre }}
                              </div>
                              <a
                                v-if="swc.servicio.infoExtra || getAdjuntosServicio(swc.servicio).length > 0"
                                href="#"
                                class="text-landing sub text-decoration-underline pointer"
                                data-bs-toggle="modal"
                                :data-bs-target="`#infoExtraModalExtra${reserva.id}-${swc.servicio.id}`"
                                @click.prevent.stop>
                                + {{ $t('general.info') }}
                              </a>
                              <button
                                v-if="
                                  isMisReservas &&
                                  swc.servicio.seguro &&
                                  swc.servicio.subtipo === 'cancelacion' &&
                                  reserva.documentacionSeguroCancelacion
                                "
                                class="btn-recibo ms-2"
                                @click.stop="descargarDocumentacion(reserva)">
                                <DownloadIcon class="me-1" />
                                {{ $t('botones.documentacion') }}
                              </button>
                            </div>
                            <div
                              v-if="hasServiceDates(swc.servicio)"
                              class="descripcion-servicio text-landing-light translate sub-m"
                              :class="isMisReservas ? 'small' : 'sub'">
                              {{ formatServiceDateRange(swc.servicio) }}
                            </div>
                            <div
                              v-if="swc.servicio.atributos"
                              class="descripcion-servicio text-landing-light translate sub-m"
                              :class="isMisReservas ? 'small' : 'sub'">
                              {{ getAtributos(swc.servicio) }}
                            </div>
                            <div
                              v-if="swc.servicio.descripcion"
                              class="text-landing-light translate sub-m"
                              :class="isMisReservas ? 'small' : 'sub'">
                              {{ swc.servicio.descripcion }}
                            </div>
                          </div>
                        </div>
                        <div class="d-flex align-items-center servicio-precio" :class="isMisReservas ? 'p' : 'small'">
                          <template v-if="swc.cantidad > 1">
                            <span class="fw-normal me-1">{{ swc.cantidad }} x</span>
                          </template>
                          <span v-if="!isInscripcion" class="bold">
                            {{ formatPrice(swc.servicio.precioTeorico || swc.servicio.precio) }}
                            {{ agenciaStore.getCurrency }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>

                <div class="divisor-horizontal ml-15 mr-15" />
              </template>

              <!-- COMPLEMENTOS -->
              <template
                v-if="
                  (reserva.complementos && reserva.complementos.length > 0) ||
                  (reserva.gastos && reserva.gastos.length > 0)
                ">
                <div class="p-15 text-landing">
                  <div class="small bold mb-10">
                    {{ $t('reserva.suplementos.title') }}
                  </div>

                  <template v-for="complemento in reserva.complementos" :key="complemento.codigo">
                    <div class="d-flex justify-content-between align-items-center mb-10">
                      <span class="small">{{ $t(`reserva.suplementos.${complemento.codigo}`) }}</span>
                      <span v-if="complemento.importe" class="small bold">
                        {{ formatPrice(complemento.importe) }} {{ agenciaStore.getCurrency }}
                      </span>
                    </div>
                  </template>

                  <template v-for="gasto in reserva.gastos" :key="gasto.codigo">
                    <div class="d-flex justify-content-between align-items-center mb-10">
                      <span class="small">{{ $t(`reserva.gastos.${gasto.codigo}`) }}</span>
                      <span v-if="gasto.importe && !isInscripcion" class="small bold">
                        {{ formatPrice(gasto.importe) }} {{ agenciaStore.getCurrency }}
                      </span>
                    </div>
                  </template>
                </div>

                <div class="divisor-horizontal ml-15 mr-15" />
              </template>

              <!-- TASAS -->
              <div
                v-if="reserva.precioBase > 0 && !isInscripcion"
                :class="isMisReservas ? 'px-20 py-15' : 'p-15'"
                class="text-landing">
                <div
                  class="d-flex justify-content-between align-items-center"
                  :class="{
                    'mb-2':
                      storeHabitacion.getCodigoDescuento ||
                      reserva.tasasExternasCalculadas?.filter(t => t.importe > 0)?.length > 0 ||
                      reserva.tasasInternasCalculadas?.filter(t => t.importe > 0)?.length > 0,
                  }">
                  <span class="bold" :class="isMisReservas ? 'p' : 'small'">
                    {{ $t('subtitulo.total').toUpperCase() }}
                  </span>
                  <span class="bold" :class="isMisReservas ? 'p' : 'small'">
                    {{ formatPrice(reserva.precioBase) }} {{ agenciaStore.getCurrency }}
                  </span>
                </div>
                <!-- DESCUENTOS -->
                <template v-if="storeHabitacion.getCodigoDescuento">
                  <div class="small bold mb-1">{{ $t('reserva.descuentos') }}</div>
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <div class="sub">
                      {{ storeHabitacion.getCodigoDescuento.descripcion }}
                      <span class="text-landing text-decoration-underline ml-10 sub pointer" @click="limpiarCodigo">
                        {{ $t('actions.delete') }}
                      </span>
                    </div>
                    <span v-if="!isInscripcion" class="bold text-secondary" :class="isMisReservas ? 'p' : 'small'">
                      -{{ formatPrice(reserva.descuento) }} {{ agenciaStore.getCurrency }}
                    </span>
                  </div>
                </template>
                <template
                  v-for="tasaExterna in reserva.tasasExternasCalculadas?.filter(t => t.importe > 0)"
                  :key="tasaExterna">
                  <div
                    class="d-flex justify-content-between align-items-center"
                    :class="{ 'mb-2': reserva.tasasInternasCalculadas?.filter(t => t.importe > 0)?.length > 0 }">
                    <span class="bold" :class="isMisReservas ? 'p' : 'small'">
                      {{ $t(`reserva.tasas.externas.${tasaExterna.codigo}`) }}
                    </span>
                    <span v-if="!isInscripcion" class="bold" :class="isMisReservas ? 'p' : 'small'">
                      {{ formatPrice(tasaExterna.importe) }} {{ agenciaStore.getCurrency }}
                    </span>
                  </div>
                </template>

                <template
                  v-for="tasaInterna in reserva.tasasInternasCalculadas?.filter(t => t.importe > 0)"
                  :key="tasaInterna">
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="bold" :class="isMisReservas ? 'p' : 'small'">
                      {{ $t(`reserva.tasas.internas.${tasaInterna.codigo}`) }}
                    </span>
                    <span v-if="!isInscripcion" class="bold" :class="isMisReservas ? 'p' : 'small'">
                      {{ formatPrice(tasaInterna.importe) }} {{ agenciaStore.getCurrency }}
                    </span>
                  </div>
                </template>
              </div>
            </div>
          </transition>
        </div>
      </template>

      <!-- IMPORTE TOTAL -->
      <div v-if="!isInscripcion" :class="isMisReservas ? 'px-20 py-15' : 'p-15'" class="card-total-final">
        <div class="d-flex justify-content-between align-items-center">
          <span class="p text-landing semibold">{{ $t('subtitulo.importeTotal').toUpperCase() }}</span>
          <span class="h5 text-landing p-m semibold-m">
            {{ formatPrice(calculaPrecioTotalReservas(resumenReservas)) }} {{ agenciaStore.getCurrency }}
          </span>
        </div>
      </div>
    </template>

    <!-- MODALES -->
    <Teleport to="body">
      <template v-for="reserva in resumenReservas" :key="`reserva-${reserva.id}`">
        <template
          v-for="swc in getServiciosPaqueteBasico(reserva).filter(
            s => s.servicio.infoExtra || getAdjuntosServicio(s.servicio).length > 0
          )"
          :key="`modal-incluido-${swc.servicio.id}`">
          <InfoExtraModal
            :modal-id="`infoExtraModalPB${reserva.id}-${swc.servicio.id}`"
            :title="swc.servicio.nombre"
            :content="swc.servicio.infoExtra"
            :adjuntos="getAdjuntosServicio(swc.servicio)"
            :style-vars="styleVars" />
        </template>
        <template
          v-for="swc in getServiciosExtras(reserva).filter(
            s => s.servicio.infoExtra || getAdjuntosServicio(s.servicio).length > 0
          )"
          :key="`modal-extra-${swc.servicio.id}`">
          <InfoExtraModal
            :modal-id="`infoExtraModalExtra${reserva.id}-${swc.servicio.id}`"
            :title="swc.servicio.nombre"
            :content="swc.servicio.infoExtra"
            :adjuntos="getAdjuntosServicio(swc.servicio)"
            :style-vars="styleVars" />
        </template>
        <template
          v-for="swc in getServiciosPaqueteBasicoUpsell(reserva).filter(
            s => s.servicio.infoExtra || getAdjuntosServicio(s.servicio).length > 0
          )"
          :key="`modal-upsell-${swc.servicio.id}`">
          <InfoExtraModal
            :modal-id="`infoExtraModalUpsell${reserva.id}-${swc.servicio.id}`"
            :title="swc.servicio.nombre"
            :content="swc.servicio.infoExtra"
            :adjuntos="getAdjuntosServicio(swc.servicio)"
            :style-vars="styleVars" />
        </template>
      </template>
    </Teleport>

    <ModalBase
      :show="showModalCondiciones"
      :style-vars="styleVars"
      :title="$t('general.condiciones')"
      :submit-text="$t('botones.aceptar')"
      hide-cancel
      @on-close="showModalCondiciones = false"
      @on-submit="showModalCondiciones = false">
      <template #body>
        <span v-translate-forced class="small text-landing">{{ observacionesAlojamiento }}</span>
      </template>
    </ModalBase>
  </div>
</template>

<script setup>
  import { ref, computed, onMounted } from 'vue';
  import { useI18n } from 'vue-i18n';
  import moment from 'moment-timezone';
  import { formatDateRangeDDmm } from '@/helpers/dateUtiles';
  import { calculaPrecioTotalReservas } from '@/helpers/viajesGrupos';
  import { formatPrice } from '@/helpers/numberUtils';
  import { getNombreTipoRegimen } from '@/helpers/regimenesUtils';
  import {
    getAtributosConcatenados,
    getCategoriasServiciosMetaData,
    TipoIconoServicio,
  } from '@/helpers/serviciosUtils';
  import accommodationIcon from '@/assets/icons/alojamiento.svg';
  import IconOccupied from '@/components/Icons/IconOccupied.vue';
  import CustomIcon from '@/components/CustomIcon.vue';
  import arrowDownIcon from '@/assets/icons/arrow_down.svg';
  import arrowUpIcon from '@/assets/icons/arrow_up.svg';
  import { informacionHabitacion } from '@/store_pinia/informacionHabitacion';
  import { agenciaStoreModule } from '@/store_pinia/agencia';
  import InfoExtraModal from '@/components/modales/InfoExtraModal.vue';
  import ModalBase from '@/components/modales/ModalBase.vue';
  import activityIcon from '@/assets/icons/servicios/actividad.svg';
  import DownloadIcon from '@/components/Icons/DownloadIcon.vue';
  import { ESTADOS_RESERVA } from '@/constants/reservaConstants';
  import { ESTADOS_INVITACION_GRUPO, TIPOS_PAGO } from '@/constants/viajeConstants';
  import { landingStyleVars } from '@/helpers/landingStyleUtils';
  const { t } = useI18n();
  const storeHabitacion = informacionHabitacion();
  const agenciaStore = agenciaStoreModule();
  const isCollapsed = ref([]);
  const showModalCondiciones = ref(false);
  const observacionesAlojamiento = ref('');

  const props = defineProps({
    isMisReservas: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits(['limpiar-codigo-descuento', 'descuento-aplicado', 'recuperar-reserva']);

  const viaje = computed(() => storeHabitacion.getViaje);
  const styleVars = computed(() => (viaje.value?.style ? landingStyleVars(viaje.value.style) : null));
  const alojamiento = computed(() => storeHabitacion.getAlojamiento);
  const resumenReservas = computed(() => storeHabitacion.getResumenReservas);
  const alojamientoHasHabs = computed(() => alojamiento.value && alojamiento.value.hasHabitaciones);
  const isInscripcion = computed(
    () =>
      viaje.value.tipoPago === TIPOS_PAGO.SIN_PAGO ||
      viaje.value.invitacionGrupo?.estado === ESTADOS_INVITACION_GRUPO.ACEPTADA
  );
  const agrupacionesOrder = computed(() => {
    const agrupacionesOrder = [];
    for (const agr of storeHabitacion.getAgrupacionesServicios) {
      agrupacionesOrder[agr.id] = agr.order;
    }
    return agrupacionesOrder;
  });

  function getAtributos(servicio) {
    const agrupacionesServicios = storeHabitacion.getAgrupacionesServicios;
    const agrupacion = agrupacionesServicios.find(agrupacion => agrupacion.id === servicio.agrupacion?.id);
    return getAtributosConcatenados(agrupacion, servicio);
  }

  function toggleCollapse(index) {
    isCollapsed.value[index] = !isCollapsed.value[index];
  }

  function getUserForIcon(index) {
    return {
      nombre: t('general.persona'),
      apellido: '',
      done: false,
      isFree: false,
      id: index + 1,
    };
  }

  function getServiciosPaqueteBasico(reserva) {
    if (!reserva.serviciosWithCantidad) {
      return [];
    }
    return Object.values(reserva.serviciosWithCantidad)
      .filter(swc => swc.servicio.paqueteBasico)
      .sort(
        (a, b) =>
          (agrupacionesOrder.value[a.servicio.agrupacion.id] ?? 0) -
          (agrupacionesOrder.value[b.servicio.agrupacion.id] ?? 0)
      );
  }

  function getServiciosPaqueteBasicoUpsell(reserva) {
    if (!reserva.serviciosWithCantidad) {
      return [];
    }
    return Object.values(reserva.serviciosWithCantidad)
      .filter(swc => swc.categoriaPaqueteBasico && swc.servicioPB && swc.servicio.id !== swc.servicioPB.id)
      .sort(
        (a, b) =>
          (agrupacionesOrder.value[a.servicio.agrupacion.id] ?? 0) -
          (agrupacionesOrder.value[b.servicio.agrupacion.id] ?? 0)
      );
  }

  function getAdjuntosServicio(servicio) {
    const adjuntos = [];
    if (servicio.adjuntosPreventa.length > 0) {
      adjuntos.push(...servicio.adjuntosPreventa);
    }
    if (props.isMisReservas && servicio.adjuntosPostventa.length > 0) {
      adjuntos.push(...servicio.adjuntosPostventa);
    }
    return adjuntos;
  }

  function getServiciosExtras(reserva) {
    const extras = [];

    if (reserva.serviciosWithCantidad) {
      Object.values(reserva.serviciosWithCantidad).forEach(swc => {
        // Servicios extras normales (no paquete, no upsell)
        if (!swc.servicio.paqueteBasico && !swc.categoriaPaqueteBasico) {
          extras.push(swc);
        }
        // Servicios extras de paquete basico con cantidad > 1 (extras)
        else if (swc.servicio.paqueteBasico && swc.cantidad > 1) {
          extras.push({
            ...swc,
            cantidad: swc.cantidad - 1,
          });
        }
        // Servicios upsell de paquete basico con cantidad > 1 (extras adicionales)
        else if (swc.categoriaPaqueteBasico && swc.cantidad > 1) {
          extras.push({
            ...swc,
            cantidad: swc.cantidad - 1, // Solo las unidades extras ( uno ya esta en incluidos)
          });
        }
      });
    }

    return extras.sort(
      (a, b) =>
        (agrupacionesOrder.value[a.servicio.agrupacion.id] ?? 0) -
        (agrupacionesOrder.value[b.servicio.agrupacion.id] ?? 0)
    );
  }

  function hasServiceDates(service) {
    return service.fechaSelected && Boolean(service?.fechaInicio && service?.fechaFin) && !service?.nulo;
  }

  function formatServiceDateRange(service) {
    if (!hasServiceDates(service)) {
      return '';
    }

    return formatDateRangeDDmm(service.fechaInicio, service.fechaFin, {
      rangeFormatter: (from, to) => `${from} - ${to}`,
    });
  }

  function getServiceIcon(servicio) {
    const agrupacionesServicios = storeHabitacion.getAgrupacionesServicios;
    const agrupacionServicios = agrupacionesServicios.find(agrupacion => agrupacion.id === servicio.agrupacion?.id);

    if (!agrupacionServicios) {
      return { type: TipoIconoServicio.IMAGE, value: '' };
    }

    if (agrupacionServicios.icono) {
      return { type: TipoIconoServicio.IMAGE, value: agrupacionServicios.icono };
    } else {
      const serviciosMetaData = getCategoriasServiciosMetaData().find(
        ({ selector }) => selector === agrupacionServicios.tipo
      );
      if (serviciosMetaData?.icono) {
        return { type: TipoIconoServicio.ICON, value: serviciosMetaData.icono };
      }
    }
  }

  function getAlojamientoInfo(alojamiento) {
    const info = [];

    if (alojamiento.fechaInicio && alojamiento.fechaFin) {
      const inicio = moment(alojamiento.fechaInicio);
      const fin = moment(alojamiento.fechaFin);
      const noches = fin.diff(inicio, 'days');
      const nochesText = noches === 1 ? t('general.noche') : t('general.noches');
      info.push(`${noches} ${nochesText}`);
    }

    if (alojamiento.habitacion?.tipo?.nombre) {
      info.push(alojamiento.habitacion.tipo.nombre);
    }

    if (alojamiento.habitacion?.tipoRegimen?.nombre) {
      info.push(getNombreTipoRegimen(alojamiento.habitacion.tipoRegimen.nombre));
    }

    return info.join(' / ');
  }

  function goToAlojamiento(alojamientoId) {
    const url = `/alojamientos/${alojamientoId}`;
    window.open(url, '_blank');
  }

  function limpiarCodigo() {
    emit('limpiar-codigo-descuento');
  }

  function recuperarReserva() {
    emit('recuperar-reserva');
  }

  function descargarDocumentacion(reserva) {
    if (reserva?.documentacionSeguroCancelacion) {
      window.open(reserva.documentacionSeguroCancelacion, '_blank');
    }
  }

  function getPrecioIncremento(swc) {
    if (swc.categoriaPaqueteBasico && swc.servicioPB) {
      const newPrecio = swc.servicio.precioTeorico;
      const originalPrecio = swc.servicioPB.precioTeorico;
      return newPrecio - originalPrecio;
    }
    return 0;
  }

  function openModalCondicionesAlojamiento(observaciones) {
    observacionesAlojamiento.value = observaciones;
    showModalCondiciones.value = true;
  }

  onMounted(() => {
    isCollapsed.value = resumenReservas.value.map(() => false);
  });
</script>

<style lang="scss" scoped>
  .card-persona {
    border-radius: var(--bs-border-radius-xl);
    border: 1px solid rgba(var(--landing-text-color-rgb, var(--bs-primary-rgb)), 0.2);
    background: var(--landing-background-color, white);
    font-family: var(--landing-text-font, inherit);

    .persona-header {
      background-color: rgba(var(--landing-text-color-rgb, var(--bs-primary-rgb)), 0.1);
      border-top-left-radius: var(--bs-border-radius-xl);
      border-top-right-radius: var(--bs-border-radius-xl);

      &.collapsed {
        border-bottom-left-radius: var(--bs-border-radius-xl);
        border-bottom-right-radius: var(--bs-border-radius-xl);
      }

      .icono-persona {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;

        .icono-ocupado {
          width: 24px !important;
          height: 24px !important;
          font-size: 12px !important;
          border-width: 1px !important;
        }
      }
    }

    .servicio-item {
      .servicio-icon {
        width: 14px;
        height: 14px;
        font-size: 14px;
        margin-right: 8px;
        margin-top: 2px;
        flex-shrink: 0;
      }

      .descripcion-servicio {
        margin-bottom: 3px;
      }
      .servicio-precio {
        white-space: nowrap;
        text-align: right;
      }

      &:last-child {
        margin-bottom: 0 !important;
      }
    }

    .divisor-horizontal {
      border-top: 1px solid rgba(var(--landing-text-color-rgb, var(--bs-primary-rgb)), 0.2);
    }
  }

  .card-total-final {
    background-color: rgba(var(--landing-text-color-rgb, var(--bs-primary-rgb)), 0.1);
    border-radius: var(--bs-border-radius-xl);
  }

  .text-landing-light {
    color: rgba(var(--landing-text-color-rgb, var(--bs-primary-rgb)), 0.8);
  }

  .collapse-enter-active,
  .collapse-leave-active {
    transition: all 0.3s ease;
  }

  .collapse-enter-from,
  .collapse-leave-to {
    opacity: 0;
    max-height: 0;
  }

  .collapse-enter-to,
  .collapse-leave-from {
    opacity: 1;
    max-height: 1000px;
  }

  .btn-recibo {
    border: none;
    background: none;
    display: flex;
    align-items: center;
  }

  .alojamiento-nombre {
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
</style>
